import EcomWayfinder from '@/components/blocks/ecom_wayfinder/EcomWayfinder';

export default async function EcomWayfinderContent({ block, position }) {
  const { items } = block.ecom_wayfinder;
  const linkList = items
    .map((item) => {
      return {
        ...item,
        url: item.reference?.[0]?.url
      };
    })
    .filter(Boolean);

  return <EcomWayfinder block={block} position={position} items={linkList} />;
}
